module.exports = __webpack_public_path__ + "img/btn_apk.375a82ab.png";